import { render, staticRenderFns } from "./StudioTeachersTab.vue?vue&type=template&id=007d1e68&scoped=true"
import script from "./StudioTeachersTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioTeachersTab.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioTeachersTab.vue?vue&type=style&index=0&id=007d1e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d1e68",
  null
  
)

export default component.exports